import { Injectable } from '@angular/core';
import { TranslateLoader } from '@ngx-translate/core';
import { Observable, of } from 'rxjs';
import lang from 'src/assets/i18n/en.json';

@Injectable({
  providedIn: 'root',
})
export class CraftTranslateLoaderService implements TranslateLoader {
  constructor() {}

  public getTranslation(_langName: string): Observable<any> {
    return of(lang);
  }
}
